import React from 'react';

import useWindowDimensions from '@src/Common/Hooks/useWindowDimensions';

import ButtonLiveTiles from '@src/Components/Atoms/Button/ButtonLiveTiles/ButtonLiveTiles';

import styles from './RepoBannerSection.module.scss';

const RepoBannerSection = () => {
  const { width } = useWindowDimensions();
  const handleBg = () => {
    if (width >= 1280) {
      return 'repo-desktop.png';
    } else if (width >= 768 && width < 1280) {
      return 'repo-desktop.png';
    } else {
      return 'repo-mobile.png';
    }
  };

  return (
    <div className={styles['container']} data-testid="repo-banner-section">
      <div className={styles['bottom-content']}>
        <div
          className={styles['container-wapper']}
          style={{
            backgroundImage: `url(./assets/img/png/${handleBg()})`
          }}
          data-testid="game-live-tiles"
        >
          <div className={styles['content-wrapper']}>
            {/* <p className={styles['title-wrapper']}>REPOSITORY ACCESS</p> */}
            <div className={styles['button-wrapper']}>
              <ButtonLiveTiles
                color="black"
                type="repo"
                onClick={() =>
                  window.open(process.env.MYTHIC_REPOSITORY_URL, '_blank')
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepoBannerSection;
